<div class="card">
  <rqa-page-title [title]="'messages.title' | translate"> </rqa-page-title>
  <p-table
    [value]="messages"
    [tableStyle]="{ 'min-width': '50rem' }"
    [scrollable]="true"
    [scrollHeight]="'800px'"
    dataKey="sentTime"
    [sortMode]="'single'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="recipient">
          {{ 'messages.list.recipient' | translate }} <p-sortIcon field="recipient"></p-sortIcon>
        </th>
        <th pSortableColumn="sentTime">
          {{ 'messages.list.sentTime' | translate }} <p-sortIcon field="sentTime"></p-sortIcon>
        </th>
        <th pSortableColumn="title">{{ 'messages.list.title' | translate }} <p-sortIcon field="title"></p-sortIcon></th>
        <th pSortableColumn="read">{{ 'messages.list.read' | translate }} <p-sortIcon field="read"></p-sortIcon></th>
        <th style="width: 4rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-message let-expanded="expanded">
      <tr>
        <td>{{ message.recipient }}</td>
        <td>{{ message.sentTime | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ message.title }}</td>
        <td class="text-center">
          <i
            [class]="message.read ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"
            [pTooltip]="(message.read ? 'users.search.enabled.yes' : 'users.search.enabled.no') | translate"
          ></i>
        </td>
        <td>
          <button
            type="button"
            pButton
            [pRowToggler]="message"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template #expandedrow let-message>
      <tr>
        <td colspan="5">
          <div class="p-4">
            <div class="message-details" [innerHTML]="message.content"></div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
